import { render, staticRenderFns } from "./registration-modals.vue?vue&type=template&id=49892564&scoped=true&"
import script from "./registration-modals.vue?vue&type=script&lang=ts&"
export * from "./registration-modals.vue?vue&type=script&lang=ts&"
import style0 from "./registration-modals.vue?vue&type=style&index=0&id=49892564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49892564",
  null
  
)

export default component.exports